<div class="layout-column full-height">
  <ul id="myUL">
    <app-price-plan-tree-node *ngFor="let pricePlan of pricePlansBundleHierarchy"
                              [selectedPricePlanId]="selectedPricePlanId"
                              [pricePlan]="pricePlan"
                              [expandedNodesMap]="expandedNodesMap"
                              (viewPricePlanDrillDownEvent)="viewPricePlanDrillDownEvent.emit($event)"
                              (toggleExpandEvent)="onToggleNodeExpand($event.ixExpanded, $event.pricePlanId)"
                              (selectPricePlanEvent)="selectPricePlanEvent.emit($event)">
    </app-price-plan-tree-node>
  </ul>
</div>
